<template>
    <ns-modal
        v-model="dialog"
        :fullscreen="fullScreenModals"
        id="languageSelector"
        :title="txc.edit_pref_language"
        @input="closeDialog"
    >
        <server-error v-if="!!dialogError" :error="dialogError" />
        <v-form @submit.prevent ref="languageForm">
            <p>{{ txc.pref_language_desc }}</p>
            <section>
                <div class="field-label">{{ txc.current_pref_language }}</div>
                <div class="field-value" ref="language_display">{{ prefLanguageDisplayName }}</div>
            </section>
            <div class="field-label">{{ txc.new_pref_language }}</div>
            <v-select class="mb-3" :items="languageList" v-model="selectedPreferredLanguage"/>
        </v-form>
        <template v-slot:actions>
            <v-layout column>
                <v-flex xs12>
                    <button
                        :disabled="!selectedPreferredLanguage"
                        @click="updatePrefLang"
                        block
                        class="primary-hit mb-2 fluid"
                        flat
                        id="updateLangDialogBtn"
                        ref="updateLangDialogBtn"
                    >{{ sharedStrings.generic.save }}</button>
                </v-flex>
                <v-spacer/>
                <v-flex xs12>
                    <button
                        id="closeLangDialogBtn"
                        flat
                        block
                        class="secondary-hit fluid"
                        @click="closeDialog"
                    >{{ sharedStrings.generic.cancel }}</button>
                </v-flex>
            </v-layout>
        </template>
    </ns-modal>
</template>

<script>
import * as ruleSet from '../../repositories/globalRules.js';
import { ProfileService } from '@nuskin/ns-account';
import { mapGetters, mapActions } from 'vuex';

import { NsModal } from '@nuskin/design-components';
import ServerError from '../ServerError';
import profileUtils from '../../repositories/profileUtils';

export default {
    components: {
        NsModal,
        ServerError
    },
    data() {
        return {
            ruleSet,
            dialog: true,
            dialogError: null,
            selectedPreferredLanguage: ''
        };
    },
    computed: {
        ...mapGetters({
            txc: 'translationsCommunication',
            fullScreen: 'mobileView',
            account: 'account',
            languageList: 'languageList',
            prefLanguageDisplayName: 'prefLanguageDisplayName',
            sharedStrings: 'sharedStrings'
        })
    },
    methods: {
        ...mapActions(['setAccount', 'updatePreferredLanguage']),
        closeDialog() {
            this.dialogError = null;
            this.$refs.languageForm.reset();
            profileUtils.publishAnalytics(
                this.$analytics.category.communications,
                'language_preference_dialog',
                'closed'
            );
            this.$emit('closeDialog');
        },
        updatePrefLang() {
            this.updatePreferredLanguage(this.selectedPreferredLanguage);
            let prefLang = { preferredLanguage: this.selectedPreferredLanguage };
            ProfileService.updateAccountInfo(prefLang)
                .then(response => {
                    if (response && response.data && response.data.account) {
                        profileUtils.publishAnalytics(
                            this.$analytics.category.communications,
                            'language_preference_update',
                            prefLang
                        );
                        this.closeDialog();
                    }
                })
                .catch(error => {
                    this.dialogError = error;
                });
        }
    }
};
</script>

<style scoped>
</style>
